export enum EnvironmentEnum {
  dev = 'dev',
  preprod = 'preprod',
  prod = 'prod'
}

export interface Tokens {
  accessToken: string;
  idToken: string;
}

export enum TypeOfPolicy {
  Auto = 'auto',
  Home = 'home',
  Umbrella = 'umbrella'
}

export interface PolicyView {
  environment: EnvironmentEnum;
  type: TypeOfPolicy;
  policyNumber: string;
  vehicleId?: string;
  tokens: Tokens;
  partnerId: string;
  sourceId: string;
  showPolicyDocuments: boolean;
}
